import React from 'react'
import { ActionBar, Box, Divider, Flex, Text } from '@chilipiper/design-system'
import { Icon } from '@chilipiper/design-system/src/new'
import { IconInformation } from '@chilipiper/icons/figma-generated/src/icon'
import { useTranslations } from '../../../context/TranslationContext'
import { DisplayDate } from './DisplayDate'

type Props = {
  date: { end: string; start: string }
  onClick: () => void
  timezone: string
}

export const PreviousSchedule = ({ date, onClick, timezone }: Props) => {
  const [previousDateTimeBooked, cancelRescheduling] = useTranslations([
    'previousDateTimeBooked',
    'cancelRescheduling',
  ])
  return (
    <Box
      mx={3}
      bg='bg/container-highlight'
      boxShadow='border/on-major'
      borderRadius={12}
      overflow='hidden'
    >
      <Flex gap={3} px={6} py={3}>
        <Icon mt={1} flexShrink={0} icon={IconInformation} color='icon/inform' />
        <Box>
          <Text color='text/body-major' textStyle='body-multiline' display='block'>
            {previousDateTimeBooked ?? 'Previous schedule'}
          </Text>
          <Text color='text/body-moderate' textStyle='body-multiline'>
            <DisplayDate date={date} timezone={timezone} />
          </Text>
        </Box>
      </Flex>
      <Divider />
      <ActionBar variant='nested'>
        <ActionBar.Button variant='minor' onClick={onClick}>
          {cancelRescheduling ?? 'Cancel Rescheduling'}
        </ActionBar.Button>
      </ActionBar>
    </Box>
  )
}
